import UICopyButton from 'UIComponents/button/UICopyButton';
import { jsx as _jsx } from "react/jsx-runtime";
const valueWhenCopiedIdentity = v => v;
const selectionSet = elem => {
  const sel = document.getSelection();
  if (sel) {
    const range = document.createRange();
    range.selectNodeContents(elem);
    sel.removeAllRanges();
    sel.addRange(range);
  }
};
const selectionClear = () => {
  const sel = document.getSelection();
  if (sel) {
    sel.removeAllRanges();
  }
};
const makeCopyListener = valueAndFormats => evt => {
  const clipboardData = evt.clipboardData;
  valueAndFormats.forEach(({
    value,
    format
  }) => {
    if (clipboardData) {
      clipboardData.setData(format, value);
    }
    evt.preventDefault();
  });
};
const copy = valueAndFormats => {
  selectionSet(document.body);
  const listener = makeCopyListener(valueAndFormats);
  document.addEventListener('copy', listener);
  try {
    document.execCommand('copy');
  } finally {
    document.removeEventListener('copy', listener);
  }
  selectionClear();
};
export const CopyRichTextButton = ({
  value,
  htmlValue,
  valueWhenCopied = valueWhenCopiedIdentity,
  hint,
  tooltipPlacement,
  use,
  size,
  children
}) => {
  return /*#__PURE__*/_jsx(UICopyButton, {
    value: value,
    valueWhenCopied: valueWhenCopied,
    onClick: () => {
      copy([{
        value: valueWhenCopied(value),
        format: 'text/plain'
      }, {
        value: htmlValue,
        format: 'text/html'
      }]);
    },
    hint: hint,
    tooltipPlacement: tooltipPlacement,
    use: use,
    size: size,
    className: "m-bottom-4",
    children: children
  });
};